<ng-container *ngIf="isLoggedIn && route && toggleFeatureView">
    <div class="navigation-item-container" [class.close]="!isExpanded">
        <ul class="list-menu">
            <li>
                <a [routerLinkActive]="['active']" (click)="opened = !opened" class="a__parent" [pTooltip]="!isExpanded ? (route.name | translate) : ''">
                    <div class="list-menu__parent">
                        <i [class]="route.icon + ' menu-icon'"></i>
                        <span class="fade item-menu text-menu" [class.visible]="isExpanded" [translate]="route.name"></span>
                    </div>
                    <i  class="pi pi-chevron-down list-menu__parent_i" [ngClass]="{'rotate': opened}" *ngIf="route.subRoutes && route.subRoutes.length > 0"></i>
                </a>
                <ng-container *ngIf="route.subRoutes && route.subRoutes.length > 0">
                        <ul class="submenu" [class.visible]="opened" [class.hide-children]="!opened" [class.show-children]="opened">
                            <li *ngFor="let subRoute of route.subRoutes" [pTooltip]="!isExpanded ? (subRoute.name | translate) : ''">
                                <!-- Using for toggle feature -->
                                <a *ngIf="subRoute.id !== routeId.EXPORT_CREATION || (subRoute.id === routeId.EXPORT_CREATION && toggleFeatureView.displayDevelopmentItems)"
                                    [routerLink]="'/' + subRoute.route" [queryParams]="subRoute.params"
                                    [routerLinkActive]="['active']">
                                    <span class="material-symbols-outlined">{{subRoute.icon}}</span>
                                    <span class="fade item-menu text-menu" [class.visible]="isExpanded" [translate]="subRoute.name"></span>
                                </a>
                            </li>
                        </ul>
                </ng-container>

            </li>
        </ul>

    </div>
</ng-container>
